import { render, staticRenderFns } from "./BodyMessageOne.vue?vue&type=template&id=45606574&scoped=true&"
import script from "./BodyMessageOne.vue?vue&type=script&lang=js&"
export * from "./BodyMessageOne.vue?vue&type=script&lang=js&"
import style0 from "./BodyMessageOne.vue?vue&type=style&index=0&id=45606574&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45606574",
  null
  
)

export default component.exports